module.exports = __webpack_public_path__ + "img/leftcloud.87fa7114.svg";